<div class="fieldselector-dialog">
    <div class="popup-msg-content" ng-class="{alert:options.alert}">
        <h1>{{$ctrl.header|translate:language}}</h1>
        <div class="message">{{$ctrl.message|translate:language}}</div>
        <hr/>
        <div ng-if="$ctrl.fieldPickerTree">
            <c-tree-explorer config="$ctrl.fieldPickerConfig"></c-tree-explorer>
        </div>
        <div ng-if="$ctrl.listConfig">
            <c-checkbox-list class="property-text" config="$ctrl.listConfig" editable="true" validation=""/>
        </div>
        <div ng-repeat="option in $ctrl.options" class="field-selector-option">
            <c-checkbox enabled="$ctrl.selectedItems.length === 1" checked="option.value" label="option.text|translate" />
            <p ng-if="option.description">{{option.description|translate}}</p>
        </div>
        <div class="popup-button-content">
            <span><button class="popup-msg-button btn-primary" ng-click="$ctrl.ok()" ng-class="{alert:options.alert}"><span>{{$ctrl.buttonSave}}</span></button></span>
            <span><button id="cancel" class="popup-msg-button" ng-click="$ctrl.cancel()"><span>{{$ctrl.buttonCancel}}</span></button></span>
        </div>
    </div>
</div>